import clsx from 'clsx';
import { colors } from '../../../colors';
import type { InputProps } from './Input.types';

export function MadfarmInput(props: InputProps) {
    return (
        <div
            className={clsx(
                'flex flex-col gap-1 w-full items-start',
            )}
        >
            {
                props.label &&
                <span
                    style={{ fontFamily: "Manrope" }}
                    className={clsx(
                        'text-label-md font-semibold text-brandPrimary-800',
                    )}
                >
                    {props.label}
                    {
                        props.required && <span className='text-red-600'> *</span>
                    }
                </span>
            }
            <div
                className={clsx(
                    'flex box-shadow-xs items-center gap-2 border rounded-lg h-[48px] max-h-[48px] justify-start px-3.5 py-0 w-full',
                    {
                        'bg-white border-neutral-300': !props.disabled && !props.error,
                        'bg-[rgba(242,242,250,1)] border-neutral-300': props.disabled,
                        'bg-white border-red-600': props.error && !props.disabled,
                    },
                )}
            >
                {props.startIcon && props.startIcon({ color: colors.neutral[600], size: 20 })}
                <input
                    key={props.id}
                    id={props.id}
                    autoFocus={props.autofocus}
                    autoComplete={props.autocomplete}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    value={props.value}
                    defaultValue={props.defaultValue}
                    onChange={(e) => {
                        props.onChange ? props.onChange(e) : props.onChangeText && props.onChangeText(e.target.value);
                    }}
                    onFocus={(e) => {
                        props.onFocus?.(e);
                    }}
                    onBlur={(e) => {
                        props.onBlur?.(e)
                    }}
                    style={{
                        border: 0,
                        outline: 0,
                        height: '20px',
                        width: '100%',
                        fontFamily: "Manrope"
                    }}
                    className={clsx(
                        'bg-transparent text-text-md text-left text-neutral-700 decoration-0 p-0 ring-0 focus:ring-0 font-medium disabled:text-neutral-500',
                        'placeholder:text-text-md placeholder:text-neutral-500 placeholder:font-medium',
                    )}
                />
                {props.endIcon && props.endIcon({ color: colors.neutral[600], size: 20 })}

            </div>
            {props.supportingText && (
                <span
                    className={clsx(
                        'text-sm font-semibold',
                        // props.supportingTextClassName,
                        {
                            'text-red-500': props.error,
                            'text-neutral-400': !props.error,
                        },
                        // props.error && props.supportingTextClassNameError,
                        // props.disabled && props.supportingTextClassNameDisabled,
                    )}
                >
                    {props.supportingText}
                </span>
            )}
        </div>
    );
}